import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: ${props => props.relative? 'relative' : 'static'};
  margin: ${props => props.relative? null : '80px 0'};
  @media (max-width: 768px) {
    margin: ${props => props.relative? null : '20px 0'};
  }
`;

const AbsoluteContainer = styled.div`
  position: ${props => props.absolute? 'absolute' : 'static'};
  margin-top: ${props => props.absolute? '200px' : null};
  width: 100%;
  padding: 0 40px;

  @media (max-width: 768px) {
    padding: 0px;
    margin-top: ${props => props.absolute? '100px' : null};
  }

  @media (max-width: 500px) {
    margin-top: ${props => props.absolute? '40px' : null};
  }
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Title = styled.h2`
  letter-spacing: 0px;
  color: #B6936C;
  font-size: 35px;
  font-weight: bold;
  text-transform: uppercase;
  @media (max-width: 768px) {
    font-size: 25px;
    margin-left: 25px;
  }
`;

const Parag = styled.p`
  letter-spacing: 0px;
  color: ${props => props.color};
  font-size: 14px;
  margin-right: 40px;
  line-height: 22px;
  text-align: justify;
  @media (max-width: 768px) {
    margin-right: 25px;
    margin-left: 25px;
    font-size: 12px;
    line-height: 18px;
    margin-bottom: 0;
  }
`;

const Content = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: auto;
  @media (max-width: 768px) {
    width: 90%;
  }
`;

export {
  Container,
  Title,
  InnerContainer,
  Parag,
  AbsoluteContainer,
  Content,
};